import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import queryKeys from '../reactQuery/queryKeys';
import request from '../request';
import { PartnershipSettings } from '../../../types/PartnershipSettings';

interface Params {
  affiliateId: string;
  locale: string;
}

export const getPartnershipSettings = async (
  { affiliateId, locale }: Params,
  signal?: AbortSignal
) => {
  const params = {
    affiliate_id: affiliateId,
    locale,
  };
  const query = new URLSearchParams(params).toString();

  const partnershipSettings = await request<PartnershipSettings>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/partnership?${query}`,
    method: 'GET',
    signal,
  });

  return partnershipSettings;
};

export const useGetPartnershipSettings = () => {
  const router = useRouter();
  const locale = router.locale as string;
  const affiliateId = router.query?.affiliate_id as string;

  const partnershipSettings = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.partnershipSettings(),
    queryFn: ({ signal }) => getPartnershipSettings({ affiliateId, locale }, signal),
    enabled: !!affiliateId && process.env.NEXT_PUBLIC_FEATURE_FLAG_PARTNERSHIP_PARAMETER === 'true',
  });

  return partnershipSettings;
};

export default useGetPartnershipSettings;
